export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref9675.108ac58b.jpg";